import styled from 'styled-components';

import { primitive } from '../../designTokens/primitives';

export const InputGroup = styled.div`
  /* Counters the top and bottom margins of the TextInput components */
  margin: -${primitive.$spacing2} 0 -${primitive.$spacing6} 0;

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: ${primitive.$spacing2};
`;
